import { useCallback } from 'react'
import {
	ApiPostWithToken,
	useApiPost
} from 'shared/api'
import {
	kojinApi,
	sisetuApi
} from 'interface/endpoints'
import {
	KojinMatchingResult,
	KojinMatchingFormData
} from '../kojin/match/types'
import {
	SisetuMatchingResult,
	SisetuMatchingFormData
} from '../sisetu/match/types'

export const useMatchingRequest = <Params>(
	callback: {
		onPosted?: (result: KojinMatchingResult | SisetuMatchingResult, params: Params) => void
		onError?: (reason: Error | undefined) => void
	}
) => {
	const { onPosted, onError } = callback
	return useApiPost<{
		target: 'kojin' | 'sisetu'
		form: KojinMatchingFormData | SisetuMatchingFormData,
		params: Params
	}, KojinMatchingResult | SisetuMatchingResult>(
		useCallback(
			(apiAccess, cancelToken, { target, form }, webSocketId) => {
				return ApiPostWithToken(
					apiAccess,
					target === 'kojin' ? kojinApi('/match') : sisetuApi('/match'),
					form,
					cancelToken,
					webSocketId
				)
			},
			[]
		),
		useCallback(
			(result, { params }) => {
				if (onPosted) onPosted(result, params)
				return result
			},
			[onPosted]
		),
		useCallback(
			(reason) => {
				if (onError) onError(reason)
			},
			[onError]
		)
	)
}
